/**
 * _Boilerplate.js
 */

import $ from 'jquery';
import Utilities from './Utilities';

class ExploreHover {

    constructor() {

        var myArray = [ 'center', 'left', 'right' ];
        var shapes = [ 'shape1', 'shape2', 'shape3', 'shape4', 'shape5' ];

        $('.icon-position').on('hover', function() {
            var rand = myArray[Math.floor(Math.random() * myArray.length)];
            $(this).children().css( {
                'background-position': rand,
            });
        });

    }

}
new ExploreHover();